//@flow
import { List } from 'immutable';
import FunctionStore from '../Base/functionStoreClass';
import Constants from '../../constants';
import Api from '../../APIInterfaces/stockReminders';
import SessionStore from '../Session/session';
import { emitChange, apiUpdateState, updateState, setFlagProp, reset, loadImmutableData } from '../Base/storeUtils';
import { toImmutable } from '../../Utils/immutable';

import type { HandlerAdd, StoreState } from '../Base/functionStoreClass';

export default class StockReminderStore extends FunctionStore {
  getStockReminders():List<string> {
    return loadImmutableData(this.getState(), 'stockReminders', Api.getStockReminders, List());
  }

  isStockReminderSet():boolean {
    return this._getFlag('stockReminderSet');
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {
    onSuccess(Constants.GET_STOCK_REMINDERS_SUCCESS, apiUpdateState(_getStockRemindersSuccess));
    onSuccess(Constants.SET_STOCK_REMINDER_SUCCESS, apiUpdateState(_setStockRemindersSuccess));
    onSuccess(Constants.SET_STOCK_REMINDER, _setStockReminder);
    onSuccess(Constants.LOGGED_IN, emitChange, [SessionStore]);
    onSuccess(Constants.LOGIN, emitChange, [SessionStore]);
    onSuccess(Constants.LOGOUT, reset);
    onError(Constants.GET_STOCK_REMINDERS_SUCCESS, updateState(_handleGetError));
  }
}

// if the GET fails, we don't need to keep trying
function _handleGetError(state:StoreState) {
  state.set('stockReminders', []);
}

function _setStockReminder(store:FunctionStore, data:{email:string, sku:string}) {
  Api.setStockReminder(data.email, data.sku);
}

function _getStockRemindersSuccess(state:StoreState, data:string[]) {
  state.set('stockReminders', toImmutable(data));
}

function _setStockRemindersSuccess(state:StoreState, data:string[]) {
  _getStockRemindersSuccess(state, data);
  setFlagProp(state, 'stockReminderSet', true);
}
